const redirects = {
   'url1' : { 
      landing_page : 'https://reaktion.se/', 
      name: "init-redirect" 
   },
   'url2' : { 
      landing_page : 'https://reaktion.se/om-oss', 
      name: "om-oss-redirect" 
   }
   
};

export default redirects